<script>
import { createNamespacedHelpers } from 'vuex';
import PATIENT_STORE from "@/store/stores/patient";
import { FETCH_ONE } from '@/store/stores/action-types';

const { mapGetters } = createNamespacedHelpers(PATIENT_STORE);
export default {
    name: "DataTable",

    computed: {

        ...mapGetters({
            patient: FETCH_ONE
        }),
    },

    props: {
        rows: Array,
        columns: Array,
        fixedHeader: {
            type: Boolean,
            default: false
        },
        lineNumbers: {
            type: Boolean,
            default: false
        },
        maxHeight: {
            type: Number,
            default: 900
        },
    },

    methods: {

        onSearchChange(params) {
            this.$emit('searchTerm', params.searchTerm);
        },

        rowStyle(row) {
            return parseInt(row.patienT_ID) >0 && row.patienT_ID === this.patient.patienT_ID 
                ? `text-center text-xs font-semibold leading-none bg-blue-300` 
                : `text-center text-xs font-semibold leading-none`;
        },
    },
}
</script>
<template>
    <vue-good-table
        mode="remote"
        :pagination-options="{
          enabled: false,
        }"
        :search-options="{
           enabled: true,
           trigger: 'enter',
        }"
        :rows="rows"
        :columns="columns"
        styleClass="vgt-table text-xs p-1-important table-bordered"
        :row-style-class="rowStyle"
        :max-height="`${maxHeight}px`"
        :fixed-header="fixedHeader"
        :line-numbers="lineNumbers"
        :sort-options="{
          enabled: false,
        }"
        @on-search="onSearchChange"
        @on-row-dblclick="$emit('rowDoubleClick')"
        >
        <template slot="table-row" slot-scope="props">
            <slot name="row" v-bind:row="props"></slot>
        </template>
        <template slot="table-actions">
          <slot name="table-actions"></slot>
        </template>
        </vue-good-table>
</template>
